// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cards__button___acYqL {
    position: relative;
}

.Cards__icon___sRpUp {
    --position: calc(0.2rem + var(--space-2xl) / 2);

    position: absolute;
    top: var(--position);
    left: var(--position);
}

.Cards__icon___sRpUp svg {
    width: 0.6rem;
    height: 0.6rem;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/ToolBar/Cards/Cards.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;;IAE/C,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB","sourcesContent":[".button {\n    position: relative;\n}\n\n.icon {\n    --position: calc(0.2rem + var(--space-2xl) / 2);\n\n    position: absolute;\n    top: var(--position);\n    left: var(--position);\n}\n\n.icon svg {\n    width: 0.6rem;\n    height: 0.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Cards__button___acYqL`,
	"icon": `Cards__icon___sRpUp`
};
export default ___CSS_LOADER_EXPORT___;
